import { AudioProvider } from "@/app/_providers/AudioProvider";
import DepthScroller from "@components/core/DepthScroller";

import { AudioItem } from "./AudioItem";
import { Phone } from "./Phone";
import { config } from "./config";

export function ElevenLabsMobileAppHero() {
  const items = config.map(item => <AudioItem key={item.audioUrl} {...item} />);
  return (
    <AudioProvider>
      <DepthScroller asset={<Phone />} centralElementZIndex={1} fewerOnMobile items={items} scaleRatio={0.8} />
    </AudioProvider>
  );
}

export default ElevenLabsMobileAppHero;
